
import Search from 'vux/src/components/search/index.vue'

import {debounce} from '../../utils/debounce.js'
export default {
name: 'VySearchBar',
components: {
Search,
},
props: {
placeholder: {
type: String,
required: true,
},
},
data () {
return {
keyWord: '',
/* timer: null, */
}
},
watch: {
keyWord (newVal, oldVal) {
debounce(() => {
if(newVal !== oldVal) {
this.$emit('transferSearchWord', this.keyWord)
}
}, 500)
},
},
methods: {
focusInput () {
this.$nextTick(() => {
this.$refs.inputPlace.focus()
})
},
goSearch () {
},
handle () {
this.$emit('transferSearchWord', this.keyWord)
},

cleanKeyWord () {
this.keyWord = ''
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VySearchBarXX.vue